<template>
  <v-footer app padless class="c-footer">
    <div class="c-footer__item c-footer--bold">
      MyWah &copy; 2023
    </div>

    <div v-if="isAuthenticated">
      <div>
        33 rue Pierre Poli 92130 Issy Les Moulineaux
      </div>
      <div class="c-footer__item">
        <a href="mailto:sav@mywah.fr">sav@mywah.fr</a>
      </div>
    </div>

    <div class="c-footer__item c-footer--small">
      {{ version }}
    </div>
  </v-footer>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'Footer',

  computed: {
    ...mapGetters([
      'isAuthenticated'
    ]),
    ...mapState({
      clientVersion: state => state.system.clientVersion,
      serverVersion: state => state.system.serverVersion
    }),
    version () {
      let str = this.clientVersion;
      if (this.serverVersion) {
        str += ` (API ${this.serverVersion})`;
      }

      return str;
    }
  }
};
</script>

<style lang="scss" scoped>
.c-footer {
  display: block;
  font-size: 10px;
  text-align: center;

  &--bold {
    text-transform: uppercase;
    font-weight: bold;
  }

  &--small {
    font-style: italic;
  }
}
</style>
